import { render, staticRenderFns } from "./TeethDiagram.vue?vue&type=template&id=420b6b7c&scoped=true"
import script from "./TeethDiagram.vue?vue&type=script&lang=js"
export * from "./TeethDiagram.vue?vue&type=script&lang=js"
import style0 from "./TeethDiagram.vue?vue&type=style&index=0&id=420b6b7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420b6b7c",
  null
  
)

export default component.exports